import {
  Directive,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[controlValueAccessor]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ControlValueAccessorDirective),
      multi: true,
    },
  ],
})
export class ControlValueAccessorDirective implements ControlValueAccessor {
  //==================Data====================
  private _value: any | null = null;
  onChange!: (value: any) => {};
  onTouched!: () => {};

  //============Inputs & Outputs==============
  @Input() public disabled: boolean = false;

  @Input() public set value(value: any | null) {
    this._value = value;
  }

  @Output() public onKeyup: EventEmitter<string> = new EventEmitter<string>();
  @Output() public onBlur: EventEmitter<string> = new EventEmitter<string>();

  //=================Logic====================
  public get value(): any | null {
    return this._value;
  }

  constructor() {}

  writeValue(obj: any): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  change() {
    if (typeof this.value === 'string') {
      this.value = this.value
        .replace(/<script.*?>.*?<\/script>/gi, '') // Remove script tags
        .replace(/on\w+=".*?"/gi, '') // Remove event handlers like onclick=""
        .replace(/javascript:/gi, ''); // Prevent JavaScript URLs
    }

    this.onChange(this.value);
  }
  public keyup() {
    this.onKeyup.emit(this.value);
  }

  public blur() {
    this.onBlur.emit();
    this.onTouched();
  }
}
